const regex = /{(ft_[a-zA-Z0-9_-]+)}/g;
export const transformToTrackingText = (text) => {
    const footnotes = [];
    const textWithoutFootnotes = text.replace(regex, (_match, footnoteKey) => {
        footnotes.push(footnoteKey);
        return '';
    });
    if (footnotes.length) {
        return `${textWithoutFootnotes}~${footnotes.join(',')}`;
    }
    return text;
};
//# sourceMappingURL=transformTrackingText.js.map